export const fields = [
  {
    identifier: 'code',
    rules: [{ required: true, message: 'برجاء ملء هذه الخانة' }],
    type: 'input',
  },
];
